import { render } from "./GenerateCourseConfirmationOverlay.vue?vue&type=template&id=45d8966e"
import script from "./GenerateCourseConfirmationOverlay.vue?vue&type=script&lang=js"
export * from "./GenerateCourseConfirmationOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__